import React from 'react';
import { Grid, Container } from '@material-ui/core';
import i18n from 'i18n-js';
import Title from 'components/Title';
import Layout from 'components/Layout';
import Comments from 'components/Comments';
import Logs from 'components/Logs';

import { Map, Details } from 'components/Locations';
import Can from 'components/Can';
import useStyles from './LocationDetails.styled';
import { withRouter, useParams } from 'react-router-dom';
import DocumentsWidget from 'components/Documents/Widget';

const LocationDetails = ({ history, width }) => {
  const { id } = useParams();
  const classes = useStyles();

  return (
    <Layout title={i18n.t('locations.details_title')}>
      <Container className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2} direction="row" justifyContent="space-between">
              <Grid item>
                <Title data-cy="title" title={i18n.t('locations.details_title')} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item sm={12} md={6} lg={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Details id={id} />
                  </Grid>
                  <Can I="read" a="document">
                    <Grid item xs={12}>
                      <DocumentsWidget type="Location" id={parseInt(id)} />
                    </Grid>
                  </Can>
                </Grid>
              </Grid>
              <Grid item sm={12} md={6} lg={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Map id={parseInt(id)} />
                  </Grid>
                  <Can I="read" on="event_log">
                    <Grid item xs={6}>
                      <Logs targetId={parseInt(id)} targetType="Location" title="Location logs" />
                    </Grid>
                  </Can>
                  <Grid item xs={6}>
                    <Comments type="location" id={parseInt(id)} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default withRouter(LocationDetails);
